<template>
    <div class="over_layout">
        <section class="upgrade">
            <a style="cursor: pointer" @click="$store.commit('paymentModal', true)">{{ $store.getters.t('create_resume') }}</a>
        </section>
        <section class="contact_page">
            <div class="wrapper">
                <div class="pages_header">
                    <div class="lines">
                        <h1>{{ $store.getters.t('contacts') }}</h1>
                    </div>
                    <div class="description">
                        <p>
                            {{ translations[$store.getters.locale]['start'] }}
                            <router-link
                                :to="{name: 'faq', params: {lang: $store.getters.locale }}"
                            >{{ translations[$store.getters.locale]['link'] }}</router-link>
                            {{ translations[$store.getters.locale]['end'] }}
                        </p>
                    </div>
                </div>
                <div class="contact_block clearfix">
                    <div class="contact_left_block">
                        <div class="all_title_block left_block">
                            <div class="title_block">
                                <div></div>
                                <span>{{ $store.getters.t('write_us') }}</span>
                            </div>
                        </div>
                        <div class="block">
                            <ul>
                                <li class="c_info_1" v-html="$store.getters.t('crweb_address').replace('<br><br>', '')"></li>
                                <li class="c_info_2">
                                    <a href="tel:+37498587373">+374 98 58 73 73</a>
                                </li>
                                <li class="c_info_3">
                                    <a href="mailto:support@cvweb.ru">support@cvweb.ru</a>
                                </li>
                            </ul>
                        </div>
                        <div class="form_block">
                            <form v-on:submit.prevent="sendComment">
                                <input
                                    class="inp_type"
                                    v-validate="'required|min:3'"
                                    :class="errors.first('name') ? 'invalid' : ''"
                                    :placeholder="$store.getters.t('name')"
                                    name="name"
                                    type="text"
                                    v-model="name"
                                    required
                                >
                                <input
                                    name="email"
                                    class="inp_type"
                                    v-validate="'required|email'"
                                    :class="errors.first('email') ? 'invalid' : ''"
                                    :placeholder="$store.getters.t('email')"
                                    type="email"
                                    v-model="email"
                                    required
                                >
                                <textarea
                                    :placeholder="$store.getters.t('description')"
                                    name="comment"
                                    v-validate="'required'"
                                    :class="errors.first('comment') ? 'invalid' : ''"
                                    v-model="comment"
                                    required
                                ></textarea>
                                <input class="inp_send" type="submit" :value="$store.getters.t('send')">
                            </form>
                        </div>
                        <div id="maps">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1524.1832888015851!2d44.51831650060976!3d40.17865471670326!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abdacebb0f85b%3A0x78958a772a1511ed!2sCreative+Web+Yerevan!5e0!3m2!1sru!2s!4v1548944537256"
                                width="100%"
                                height="100%"
                                frameborder="0"
                                style="border:0"
                                allowfullscreen
                            ></iframe>
                        </div>
                    </div>
                    <div class="contact_right_block">
                        <div class="block_soc">
                            <div class="name_block">{{ translations[$store.getters.locale]['in_social'] }}</div>
                            <div class="info">
                                <div class="soc">
                                    <a :href="$store.getters.t('facebook_foot_link')" target="_blank">
                                        <img src="/vue/images/soc_icon_1.png">
                                        <img src="/vue/images/soc_icon_hover_1.png">
                                    </a>
                                    <a  :href="$store.getters.t('instagram_foot_link')"   target="_blank">
                                        <img src="/vue/images/instagram_icon.png">
                                        <img src="/vue/images/instagram_icon-hover.png">
                                    </a>
                                    <!--<a href="#"  target="_blank">-->
                                    <!--<img src="/vue/images/soc_icon_2.png">-->
                                    <!--<img src="/vue/images/soc_icon_hover_2.png">-->
                                    <!--</a>-->
                                    <a href='https://www.linkedin.com/company/cvweb-ru'  target="_blank">
                                        <img src='/vue/images/soc_icon_3.png'>
                                        <img src='/vue/images/soc_icon_hover_3.png'>
                                    </a>
                                    <!--<a href="https://www.facebook.com/CVwebRussian" target="_blank">-->
                                        <!--<img src="/vue/images/soc_icon_1.png">-->
                                        <!--<img src="/vue/images/soc_icon_hover_1.png">-->
                                    <!--</a>-->
                                    <!--<a href="https://www.instagram.com/cvweb.ru/" target="_blank">-->
                                        <!--<img src="/vue/images/soc_icon_2.png">-->
                                        <!--<img src="/vue/images/soc_icon_hover_2.png">-->
                                    <!--</a>-->
                                    <!--<a href="#" target="_blank">-->
                                    <!--<img src="/vue/images/soc_icon_3.png">-->
                                    <!--<img src="/vue/images/soc_icon_hover_3.png">-->
                                    <!--</a>-->
                                </div>
                            </div>
                        </div>
                        <div class="block_fb">
                            
                     
                        
                            
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                name: "",
                email: "",
                comment: "",
                translations: {
                    am: {
                        start: `Մեր առաքելությունն է ստեղծել ռեզյումե կազմելու առավել հարմարավետ ծառայություն:
                  Մեզ համար շատ կարևոր է Ձեր կարծիքները և առաջարկները:
                  Ձեր հարցերի պատասխանների մեծ մասը կարող եք գտնել`,
                        link: "հաճախ տրվող հարցերի",
                        end: " բաժնում կամ պարզապես գրեք մեզ:",
                        in_social: "Մենք սոց. ցանցերում"
                    },
                    ru: {
                        start: `Наша миссия - создать самый удобный сервис для создание резюме.
                Для нас очень важна ваша мнение и заметки об ошибках. Болшенство ответов на ваши вопросы можете найди в разделе`,
                        link: "часта задоваемые вопросы,",
                        end: " или просто пишите нам.",
                        in_social: "Мы в соцсетях"
                    },
                    en: {
                        start: `Our mission is to create the most convenient service for creating a resume.
                  Your opinion are very important to us.
                  You can find the answers to your questions in`,
                        link: "frequently asked questions",
                        end: "page, or just write to us.",
                        in_social: "We are in social networks"
                    }
                }
            };
        },
        mounted() {
            this.$parent.getData().then(changed => {
                if (changed) {
                }
            });
        },
        methods: {
            sendComment(form) {
                if (!this.errors.items.length) {
                    this.$http({
                        method: "post",
                        url: "/api/contact/feedback",
                        data: {
                            name: this.name,
                            email: this.email,
                            comment: this.comment
                        }
                    }).then(res => {
                        if (res.data.invalid) {
                            this.$store.comment("newMessage", {
                                show: true,
                                type: "error",
                                messageTitle: this.$store.getters.t("error"),
                                message: this.$store.getters.t("server_error")
                            });
                        } else {
                            this.$store.commit("newMessage", {
                                show: true,
                                type: "success",
                                messageTitle: this.$store.getters.t("success"),
                                message: this.$store.getters.t("sent_message")
                            });
                        }
                    });
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/Contacts.vue